import { formatDate } from '@angular/common';

/** `YYYY-MM-DD` as a local date — `new Date(string)` would parse it as UTC midnight. */
export function parseDay(day: string): Date {
    const [year, month, date] = day.split('-').map(Number);
    return new Date(year, month - 1, date);
}

/** Local date as `YYYY-MM-DD` — `toISOString()` would shift it to UTC, a day early after midnight in Warsaw. */
export function formatDay(date: Date): string {
    return formatDate(date, 'yyyy-MM-dd', 'en-US');
}

/** The same day a year earlier — the earliest `from` the toolbar offers for a range ending on `day`. */
export function yearBefore(day: Date): Date {
    return new Date(day.getFullYear() - 1, day.getMonth(), day.getDate());
}

/** A real `YYYY-MM-DD` day — the round trip rejects ones like `2026-02-30`. */
export function isDay(day: string): boolean {
    return /^\d{4}-\d{2}-\d{2}$/.test(day) && formatDay(parseDay(day)) === day;
}

/** Days from `from` to `to`, both included; both parse as UTC midnight, so the difference is whole days. */
export function countDays(from: string, to: string): number {
    return (Date.parse(to) - Date.parse(from)) / 86_400_000 + 1;
}

/** An omitted `to` is today on the API side, so such a range is still moving too. */
export function endsToday(to?: string): boolean {
    return !to || to >= formatDay(new Date());
}
